<template>
  <header class="header border-bottom-0" :class="{ active: burgerActive }">
    <a class="logo" href="/">
      <img src="/img/faaren-logo.svg" />
    </a>

    <contact-button-mobile v-if="!burgerActive" class="d-block d-xl-none" style="margin: 0 auto; border-radius: 50px;"/>

    <div class="burger p-0" :class="{ active: burgerActive }" @click="burgerActive = !burgerActive">
      <span class="burger-line"></span> &nbsp; <span class="p-1 d-none d-sm-block">Menu</span>
    </div>

    <nav class="nav d-xl-flex align-items-center font-weight-bold" :class="{ active: burgerActive }">
      <a v-if="leasingFeatureFlag" href="/auto-abo/katalog" target="_self" class="icon-navbar-color">
        Auto-Abo
      </a>

      <seperator-x v-if="b2bFeatureFlag" class="w-100 d-block d-xl-none" />

      <a v-if="leasingFeatureFlag && showLeasingNavigation" href="/leasing/katalog" target="_self" class="icon-navbar-color">
        Leasing
      </a>

      <a v-if="!leasingFeatureFlag" href="/katalog" target="_self" class="icon-navbar-color">
        Autos
      </a>

      <a v-if="volvoDealsFeatureFlag" href="/marke/volvo" target="_self" class="icon-navbar-color">
        Volvo Deals <span class="badge badge-danger ml-1" style="color: #fff !important; background-color: #dc3545 !important;">Neu</span>
      </a>

      <seperator-x v-if="b2bFeatureFlag" class="w-100 d-block d-xl-none" />

      <a v-if="b2bFeatureFlag" href="/gewerbe-auto-abo" target="_self" class="icon-navbar-color">
        Gewerbekunden
      </a>

      <seperator-x class="w-100 d-block d-xl-none"/>

      <div v-if="b2bFeatureFlag" class="position-relative">
        <button
          type="button"
          :class="['icon-navbar-color', 'account-trigger', { open: accountMenuOpen }]"
          @click="accountMenuOpen = !accountMenuOpen"
          :aria-expanded="accountMenuOpen.toString()"
          ref="accountTrigger"
        >
          <img src="../../../../img/user-sharp-regular.svg" class="icon-navbar-size pr-2" alt="car catalog icon navbar"/> Konto
          <span class="dropdown-caret" aria-hidden="true"></span>
        </button>
        <transition name="account-fade">
          <div
            v-if="accountMenuOpen"
            class="account-dropdown"
            ref="accountDropdown"
          >
            <div v-if="dashboardFeatureFlag">
              <a :href="dashboardUrl + '/login'" target="_self" class="account-link d-flex justify-content-center d-xl-block">Privatkunde</a>
            </div>
            <div v-else>
              <a href="/login" target="_self" class="account-link d-flex justify-content-center d-xl-block">Privatkunde</a>
            </div>
            <a :href="b2bMarketplaceUrl + '/anmeldung'" target="_self" class="account-link">Gewerbekunden</a>
          </div>
        </transition>
      </div>

      <a v-else-if="dashboardFeatureFlag" :href="dashboardUrl + '/login'" target="_self" class="icon-navbar-color">
        <img src="../../../../img/user-sharp-regular.svg" class="icon-navbar-size pr-2" alt="car catalog icon navbar"/> Konto
      </a>

      <a v-else href="/login" target="_self" class="icon-navbar-color">
        <img src="../../../../img/user-sharp-regular.svg" class="icon-navbar-size pr-2" alt="car catalog icon navbar"/> Konto
      </a>

      <seperator-x class="w-100 d-block d-xl-none" />

      <contact-button :navbarModalPhoneNumber="navbarModalPhoneNumber"  class="w-100" style="border-radius: 50px;" />
    </nav>
  </header>
</template>

<script>
import axios from 'axios'
export default {
    name: "NavBar",
    props: {
        navbarModalPhoneNumber: {
            default: false,
        },
        b2bMarketplaceUrl: {
            type: String
        },
        dashboardUrl: {
            type: String
        }
    },
    data() {
        return {
            burgerActive: false,
            b2bFeatureFlag: false,
            leasingFeatureFlag: false,
            showLeasingNavigation: false,
            dashboardFeatureFlag: false,
            volvoDealsFeatureFlag: false,
            accountMenuOpen: false
        };
    },
    watch: {
        burgerActive(active) {
            if (!active) {
                this.accountMenuOpen = false;
            }
        }
    },
    async mounted() {
        const responseB2B = await axios.get(`/feature-flag-is-on/${'navbar.b2b'}`)
        this.b2bFeatureFlag = !!responseB2B.data

        const responseLeasing = await axios.get(`/feature-flag-is-on/${'leasing_catalog_active'}`)
        this.leasingFeatureFlag = !!responseLeasing.data

        const responseShowLeasingNav = await axios.get(`/feature-flag-is-on/${'show_leasing_navigation'}`)
        this.showLeasingNavigation = !!responseShowLeasingNav.data

        const responseDashboard = await axios.get(`/feature-flag-is-on/${'standalone_dashboard'}`)
        this.dashboardFeatureFlag = !!responseDashboard.data

        const responseVolvoDeals = await axios.get(`/feature-flag-is-on/${'navbar.volvo-deals'}`).catch(() => ({ data: false }))
        this.volvoDealsFeatureFlag = !!responseVolvoDeals.data

        document.addEventListener('click', this.handleOutsideClick);
        globalThis.window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
        globalThis.window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleOutsideClick(event) {
            if (!this.accountMenuOpen) {
                return;
            }
            const trigger = this.$refs.accountTrigger;
            const dropdown = this.$refs.accountDropdown;
            const clickedInsideTrigger = trigger && trigger.contains(event.target);
            const clickedInsideDropdown = dropdown && dropdown.contains(event.target);
            if (!clickedInsideTrigger && !clickedInsideDropdown) {
                this.accountMenuOpen = false;
            }
        },
        handleResize() {
            this.accountMenuOpen = false;
        },
    }
};
</script>
